import React from "react";
export const DataContext = React.createContext({
  headerImages: {},
  section1Data: [],
  section2Data: {},
  section3Data: [],
  section4Image: "",
  section5Data: [],
});
